module.exports = __webpack_public_path__ + "static/media/webpack-logo-mobile.cf173799.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/webpack-logo-mobile.png
// module id = 62
// module chunks = 0